import moment from "moment";
import PutAPI from "../../APICalls/PutAPI";
import PostAPI from "../../APICalls/PostAPI";
import GetAPI from "../../APICalls/GetAPI";

let environment = process.env.REACT_APP_NODE_ENV;
let userAPI, notifyChefAPI, fileUploadApi, performanceAPI, emiAPI, chefMenuAPI, craverCommunicationAPI, chefChatAPI, utilityApi;
if (environment === "PRODUCTION" || environment === undefined) {
  userAPI = process.env.REACT_APP_PROD_USERAPI;
  notifyChefAPI = process.env.REACT_APP_PROD_WHATSAPP;
  fileUploadApi = process.env.REACT_APP_PROD_FILEUPLOAD;
  performanceAPI = process.env.REACT_APP_PROD_CHEFDETAILSAPI;
  emiAPI = process.env.REACT_APP_PROD_CHEFEMI;
  chefMenuAPI = process.env.REACT_APP_PROD_CHEFMENU;
  craverCommunicationAPI = process.env.REACT_APP_PROD_CRAVERCOMMUNICATIONAPI;
  chefChatAPI = process.env.REACT_APP_PROD_CHEFCHATAPI;
  utilityApi = process.env.REACT_APP_PROD_UTILITY;
} else {
  userAPI = process.env.REACT_APP_DEV_USERAPI;
  notifyChefAPI = process.env.REACT_APP_DEV_WHATSAPP;
  fileUploadApi = process.env.REACT_APP_DEV_FILEUPLOAD;
  performanceAPI = process.env.REACT_APP_DEV_CHEFDETAILSAPI;
  emiAPI = process.env.REACT_APP_DEV_CHEFEMI;
  chefMenuAPI = process.env.REACT_APP_DEV_CHEFMENU;
  craverCommunicationAPI = process.env.REACT_APP_DEV_CRAVERCOMMUNICATIONAPI;
  chefChatAPI = process.env.REACT_APP_DEV_CHEFCHATAPI;
  utilityApi = process.env.REACT_APP_DEV_UTILITY;
}

export const handleStatus = (status, setChefLevelData, setLoading, setLastUserID, lastUserID) => {
  let userChefLevelURL = userAPI + "?chefLevel=" + status;

  if (lastUserID && lastUserID !== null && lastUserID !== "") {
    userChefLevelURL += "&lastUserID=" + lastUserID;
  }

  GetAPI(userChefLevelURL)
    .then((res) => {
      if (res.data.statusCode === 200 || res.data.statusCode === 201) {
        const filteredData = res.data.body.filter(item => 
          !item.hasOwnProperty('lastUserID') || Object.keys(item).length > 2
        );
        if(lastUserID !== null){
          setChefLevelData(prevData => [...prevData, ...filteredData]);
        } else {
          setChefLevelData(filteredData);
        }
        const newLastUserID = res.data.body.find(item => item.hasOwnProperty('lastUserID'))?.lastUserID;
        if (newLastUserID || newLastUserID === "") {
          setLastUserID(newLastUserID);  
        }
        setLoading(false);
      } else {
        alert("Failed to get chefs data. Please try again later");
        setLoading(false);
      }
    })
    .catch((e) => {
      console.error(e);
      alert("Failed to get chefs data. Please try again later");
      setLoading(false);
    });
};

export const handleCorporateChefsData = (setChefs, setLoading, setLastUserID, lastUserID) => {
  let userChefLevelURL = `${userAPI}?chefLevel=Verified`;

  if (lastUserID) {
    userChefLevelURL += `&lastUserID=${lastUserID}`;
  }

  GetAPI(userChefLevelURL)
    .then((res) => {
      if (res.data.statusCode === 200 || res.data.statusCode === 201) {
        const filteredData = res.data.body.filter(
          (item) => !item.hasOwnProperty("lastUserID") || Object.keys(item).length > 2
        );

        const newChefsMap = new Map();
        filteredData.forEach((item) => {
          if (item.isVerified) {
            newChefsMap.set(item.userID, {
              value: item.userID,
              label: `${item.userName} - ${item.userKitchen}`,
            });
          }
        });

        setChefs((prevData) => {
          const combinedMap = new Map(
            [...prevData.map((chef) => [chef.value, chef]), ...newChefsMap]
          );
          return Array.from(combinedMap.values());
        });

        const newLastUserID = res.data.body.find((item) =>
          item.hasOwnProperty("lastUserID")
        )?.lastUserID;

        setLastUserID(newLastUserID || ""); 
      } else {
        alert("Failed to get chefs data. Please try again later");
      }
      setLoading(false);
    })
    .catch((e) => {
      console.error(e);
      alert("Failed to get chefs data. Please try again later");
      setLoading(false);
    });
};

export const handleCraverNotifications = (data) => {
  const dataToPost = {
    lat: data.userAddress.coordinates.split("LAT")[1].split("LONG")[0],
    lng: data.userAddress.coordinates.split("LONG")[1],
    kitchenName: data.userKitchen,
    type: "NEWCHEF"
  };

  PostAPI(craverCommunicationAPI, dataToPost)
    .then((res) => {
      if(res.data.statusCode === 200) {
        alert(res.data.body);
      }
    })
    .catch((e) => {
      alert("Failed to verify Chef.Try again!");
      console.log("Error occurred. Please try again. Error =", e);
    });
}

export const handleMenuCount = (
  data,
  setChefMenuCount,
  setSelectedChefData
) => {
  let chefMenuCountAPI =
    userAPI + "?type=MENUCOUNT&userID=" + data.userID;
  console.log("URL="+chefMenuCountAPI)
  GetAPI(chefMenuCountAPI)
    .then((res) => {
      if (res.data.statusCode === 201 || res.data.statusCode === 200) {
        setChefMenuCount(res.data.body);
        setSelectedChefData(data);
      } else {
        alert("Error in getting chef menu counts!!!");
      }
    })
    .catch((e) => {
      console.error(e);
      alert("Error in getting chef menu counts. Please try again later");
    });
};

export const handleVerify = (
  selectedChefData,
  comments,
  setLoading,
  setShowVerifyPopup
) => {
  const dataToPut = {
    userID: selectedChefData.userID,
    isVerified: true,
    verifiedTimestamp: moment().valueOf(),
    comments: comments,
    chefStatus: "VERIFIED",
  };

  PutAPI(userAPI, dataToPut)
    .then((res) => {
      notifyChef({ setShowVerifyPopup, selectedChefData });
    })
    .catch((e) => {
      setLoading(false);
      alert("Failed to verify Chef.Try again!");
      setShowVerifyPopup(false);
      console.log("Error occurred. Please try again. Error =", e);
    });
};

const notifyChef = ({ selectedChefData, setShowVerifyPopup }) => {

  alert("Verified chef successfully!!!");
  let userMobile =  selectedChefData.userMobile.startsWith("+91")? selectedChefData.userMobile.slice(3): selectedChefData.userMobile ;
  const dataToPost = {
    destination: userMobile,
    templateID: "969f9298-6f59-4116-b9f8-bef0bdffbf62",
    params: JSON.stringify([selectedChefData.userName])
  };

  PostAPI(notifyChefAPI, dataToPost)
    .then((res) => {
      if (res.data.statusCode === 201) {
        alert("your message is queued, will be delivered soon!!!");
        setShowVerifyPopup(false);
        window.location.reload();
      } else {
        alert("your message has been delivered successfully!!!");
        setShowVerifyPopup(false);
        window.location.reload();
      }
    })
    .catch((e) => {
      setShowVerifyPopup(false);
      alert(
        "Failed to deliver the message. Chef is Verified please send message manually."
      );
      console.log("Error occurred. Please try again. Error =", e);
    });
};

export const handleUpdateChef = (
  selectedChefData,
  profilePicture,
  setLoading
) => {
  setLoading(true);

    const matches = profilePicture.match(/^data:(image\/[a-zA-Z]+);base64,/);
    const fileExtension = `.${matches[1].split("/")[1]}`;
    const base64Data = profilePicture.replace(
      /^data:image\/[a-zA-Z]+;base64,/,
      ""
    );

    const dataToPost = {
      userID: selectedChefData.userID,
      fileType: fileExtension,
      fileID: selectedChefData.userID,
      flag: "CHEF",
      fileWithBase64: base64Data,
    };

  let environment = process.env.REACT_APP_NODE_ENV;
  let fileUploadApi;

  if (environment === "PRODUCTION" || environment === undefined) {
    fileUploadApi = process.env.REACT_APP_PROD_FILEUPLOAD;
  } else {
    fileUploadApi = process.env.REACT_APP_DEV_FILEUPLOAD;
  }

  PostAPI(fileUploadApi, dataToPost)
    .then((res) => {
      if (res.data.statusCode === 200) {
        alert("Uploaded image successfully");
      } else {
        alert("Error uploading image, please try again");
      }
      setLoading(false);
      window.location.reload();
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Error uploading image, please try again");
    });
};


export const handleChefDescUpdate = (selectedChefData, chefDesc, setLoading) => {
  const dataToPut = {
    userID: selectedChefData.userID,
    profileDescription: chefDesc
  };

  let ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let userAPI;

  if (ENVIRONMENT.toUpperCase() === "PRODUCTION" || ENVIRONMENT === undefined) {
    userAPI = process.env.REACT_APP_PROD_USERAPI;
  } else {
    userAPI = process.env.REACT_APP_DEV_USERAPI;
  }

  PutAPI(userAPI, dataToPut)
    .then((res) => {
      if (res.data.statusCode === 200) {
        alert("Updated profile desc successfully");
      } else {
        alert("Error Updating profile desc, please try again");
      }
      setLoading(false);
      window.location.reload();
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Error Updating profile desc, please try again");
    });
}

export const handleChefImageUpload = (
  selectedChefData,
  chefImage,
  setLoading
) => {
  setLoading(true);

  const matches = chefImage.match(/^data:(image\/[a-zA-Z]+);base64,/);
  const fileExtension = `.${matches[1].split("/")[1]}`; 
  const base64Data = chefImage.replace(/^data:image\/[a-zA-Z]+;base64,/, "");

  const dataToPost = {
    userID: selectedChefData.userID,
    fileType: fileExtension,
    flag: "CHEF_IMAGE",
    fileWithBase64: base64Data,
  };
  let ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let fileUploadApi;

  if (ENVIRONMENT.toUpperCase() === "PRODUCTION" || ENVIRONMENT === undefined) {
    fileUploadApi = process.env.REACT_APP_PROD_FILEUPLOAD;
  } else {
    fileUploadApi = process.env.REACT_APP_DEV_FILEUPLOAD;
  }

  PostAPI(fileUploadApi, dataToPost)
    .then((res) => {
      if (res.data.statusCode === 200) {
        updateUserTable(selectedChefData.userID, res.data.body, setLoading);
      } else {
        alert("Error uploading image, please try again");
      }
      setLoading(false);
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Error uploading image, please try again");
    });
};

const updateUserTable = (chefID, chefImageUrl, setLoading) => {
  const dataToPut = {
    userID: chefID,
    chefImage: chefImageUrl
  };

  let ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let userAPI;

  if (ENVIRONMENT.toUpperCase() === "PRODUCTION" || ENVIRONMENT === undefined) {
    userAPI = process.env.REACT_APP_PROD_USERAPI;
  } else {
    userAPI = process.env.REACT_APP_DEV_USERAPI;
  }

  PutAPI(userAPI, dataToPut)
    .then((res) => {
      if (res.data.statusCode === 200) {
        alert("Uploaded image successfully");
      } else {
        alert("Error uploading image, please try again");
      }
      setLoading(false);
      window.location.reload();
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Error uploading image, please try again");
    });
}

export const handleKitchenImagesUpload = (selectedChefData, kitchenImages, setLoading) => {
  setLoading(true);

  const ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  const fileUploadApi =
    ENVIRONMENT?.toUpperCase() === "PRODUCTION" || ENVIRONMENT === undefined
      ? process.env.REACT_APP_PROD_FILEUPLOAD
      : process.env.REACT_APP_DEV_FILEUPLOAD;

  // Filter out already uploaded images (URLs)
  const newImages = kitchenImages.filter((image) => image.startsWith("data:image"));

  if (newImages.length === 0) {
    console.log("No new images to upload");
    setLoading(false);
    return;
  }

  // Create an array of API promises for each new image
  const uploadPromises = newImages.map(async (image) => {
    const matches = image.match(/^data:(image\/[a-zA-Z]+);base64,/);
    const fileExtension = `.${matches[1].split("/")[1]}`;
    const base64Data = image.replace(/^data:image\/[a-zA-Z]+;base64,/, "");

    const dataToPost = {
      userID: selectedChefData.userID,
      fileType: fileExtension,
      flag: "KITCHEN_IMAGE",
      fileWithBase64: base64Data,
    };
    const res = await PostAPI(fileUploadApi, dataToPost);
    if (res.data.statusCode === 200) {
      return res.data.body; 
    } else {
      throw new Error("Error uploading image");
    }
  });

  // Execute all uploads in parallel
  Promise.all(uploadPromises)
    .then((imageUrls) => {
      // Merge new uploaded URLs with existing kitchenImages
      const updatedKitchenImages = [
        ...kitchenImages.filter((image) => !image.startsWith("data:image")), // Keep existing URLs
        ...imageUrls, // Add newly uploaded image URLs
      ];

      updateKitchenImageToUserTable(selectedChefData.userID, updatedKitchenImages, setLoading);
    })
    .catch((error) => {
      console.error(error);
      alert("Error uploading one or more images, please try again");
    })
    .finally(() => {
      setLoading(false);
    });
};


const updateKitchenImageToUserTable = (chefID, kitchenImagesUrls, setLoading) => {
  const dataToPut = {
    userID: chefID,
    kitchenImages: kitchenImagesUrls
  };

  let ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let userAPI;

  if (ENVIRONMENT.toUpperCase() === "PRODUCTION" || ENVIRONMENT === undefined) {
    userAPI = process.env.REACT_APP_PROD_USERAPI;
  } else {
    userAPI = process.env.REACT_APP_DEV_USERAPI;
  }

  PutAPI(userAPI, dataToPut)
    .then((res) => {
      if (res.data.statusCode === 200) {
        alert("Uploaded image successfully");
      } else {
        alert("Error uploading image, please try again");
      }
      setLoading(false);
      window.location.reload();
    })
    .catch((e) => {
      setLoading(false);
      console.error(e);
      alert("Error uploading image, please try again");
    });
}


export const handlePerformance = (
  data,
  setChefPerformance,
  setSelectedChefData
) => {
  let chefPerformanceURL =
    performanceAPI + "?chefID=" + data.userID + "&type=CHEFDETAILS";

  GetAPI(chefPerformanceURL)
    .then((res) => {
      if (res.data.statusCode === 201 || res.data.statusCode === 200) {
        setChefPerformance(res.data.body);
        setSelectedChefData(data);
      } else {
        alert("Error in getting chef emi data!!!");
      }
    })
    .catch((e) => {
      console.error(e);
      alert("Error in getting chef emi data. Please try again later");
    });
};

export const handleChefChat = (
  data,
  setLoading
) => {

    PostAPI(chefChatAPI, data)
      .then((res) => {
        setLoading(false);
        if(res.data.statusCode === 200 || res.data.statusCode === 201){
          alert("Message sent successfully!!!")
        } else {
          alert("Error in sending message. Please try again later");
        }
      })
      .catch((e) => {
        console.error(e);
        alert("Error in sending message. Please try again later");
        setLoading(false);
      });
};

export const handleEmiStatus = (
  data,
  setChefsEMIData,
  setChefName,
  setLoading
) => {
  const getChefsEMI = () => {
    let userChefsURL = emiAPI + "?chefID=" + data.userID;

    GetAPI(userChefsURL)
      .then((res) => {
        if (res.data.statusCode === 201 || res.data.statusCode === 200) {
          setChefsEMIData(res.data.body);
          setChefName(data.userName);
        } else {
          alert("Error in getting chef emi data!!!");
        }
      })
      .catch((e) => {
        console.error(e);
        alert("Error in getting chef emi data. Please try again later");
        setLoading(false);
      });
  };

  getChefsEMI();
};

export const handleShowMenu = (data, setSelectedChefData, setSelectedChefMenu) => {
    setSelectedChefData(data);

    let chefsMenuURL = chefMenuAPI + "?userID=" + data.userID;

    GetAPI(chefsMenuURL)
      .then((res) => {
        if (res.data.body.length > 0) {
          setSelectedChefMenu(res.data.body);
        } else {
          alert("Chef has not added any menu to show!!!");
        }
      })
      .catch((e) => {
        alert(
          "Some technical issue in fetching the menu!!! Please try again later"
        );
        console.log("Error occurred. Error =" + e);
      });
  };

  export  const handleUnverify = (comments, selectedChefData, setLoading) => {
    setLoading(true);
    const dataToPut = {
      userID: selectedChefData.userID,
      isVerified: false,
      unverifiedTimestamp: moment().valueOf(),
      comments: comments,
      chefStatus: "REMOVE",
    };

    PutAPI(userAPI, dataToPut)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          alert("Successfully Removed and Unverified the chef");
          window.location.reload();
        }
      })
      .catch((e) => {
        setLoading(false);
        console.log("Error occurred. Please try again. Error =", e);
      });
  };

  export const handleChefStatus = (status, comments, data, setLoading) => {
    setLoading(true);
    const dataToPut = {
      userID: data.userID,
      isVerified: false,
      comments:
        comments === "" || comments === "N/A" ? data.comments : comments,
      chefStatus: status.toUpperCase(),
    };

    PutAPI(userAPI, dataToPut)
      .then((res) => {
        window.location.reload();
      })
      .catch((e) => {
        setLoading(false);
        console.log("Error occurred. Please try again. Error =", e);
      });
  };

  export const getChefStatusCounts = (setCount, setLoading) => {
    setLoading(true);
    let userChefsURL = userAPI + "?userType=Chef";

    GetAPI(userChefsURL)
      .then((res) => {
        if (res.data.statusCode == 200 || res.data.statusCode == 201) {
          setCount(res.data.body);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        alert("Failed to get chefs data. Please try again later");
        setLoading(false);
      });
  }

  export const saveComment = (comments, data) => {
    const dataToPut = {
      userID: data.userID,
      comments: comments 
    };

    PutAPI(userAPI, dataToPut)
      .then((res) => {
        window.location.reload();
      })
      .catch((e) => {
        console.log("Error occurred. Please try again. Error =", e);
      });
  };

  export const saveKitchenLoc = (data) => {
    PutAPI(userAPI, data)
      .then((res) => {
        if (res.data.statusCode == 200 || res.data.statusCode == 201) {
          alert("Successfully updated data");
          window.location.reload();
        }
      })
      .catch((e) => {
        console.log("Error occurred. Please try again. Error =", e);
      });
  };

   export const getPodLocations = (setPodLocations) => {
    let podUtility = utilityApi + "?type=POD_LOCATIONS";

    GetAPI(podUtility)
      .then((res) => {
        if (res.data.statusCode == 200 || res.data.statusCode == 201) {
          setPodLocations(res.data.body);
        } 
      })
      .catch((e) => {
        console.error(e);
        alert("Failed to get pod locations. Please try again later");
      });
  }